import ReactDOM from 'react-dom';
import './index.css';
import ApolloProvider from './ApolloProvider';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

// This will load apollo provider environment to app ( a graphql structure )

ReactDOM.render(ApolloProvider, document.getElementById("root"))
reportWebVitals();
serviceWorker.register();